import React from "react"
import {t} from "@lingui/core/macro"
import Meta from "../Meta"
import Header from "../components/Header"
import Footer from "../components/Footer"
import Loader from "../loader"
import ContentHub from "../../../components/ContentHub"

export default function TravelContentHub({context, loading}) {
    const hub = context?.contentHub || {}
    const article = hub?.article

    const title = hub.view === "article" && article ? article.title : t`Explorer la bibliothèque`
    const description = hub.view === "article" && article
        ? (article.description || "")
        : t`Parcourez articles et catégories de contenu juif.`

    if (loading) {
        return (
            <div className="travel-page travel-page--home">
                <Meta context={context} title={title} description={description}/>
                <Loader/>
            </div>
        )
    }

    return (
        <div className="travel-page travel-page--home">
            <Meta context={context} title={title} description={description}/>
            <Header context={context}/>
            <div style={context.render !== "embed" ? {marginTop: 20, minHeight: "80vh"} : undefined}>
                <ContentHub context={context}/>
            </div>
            <Footer context={context}/>
        </div>
    )
}
